import styled from 'styled-components'
import { theme } from '@/client/components'
const { color } = theme

export const BlogCardWrapper = styled.a`
  display: flex;
  flex-wrap: wrap;
  &:hover {
    text-decoration: none;
  }
`
export const BlogPreview = styled.div`
  position: relative;
  width: 100%;
  border-radius: 15px;
  overflow: hidden;
  height: 250px;
  background: ${color.grayscale.light};
  & img {
    height: 100%;
    display: flex;
    align-items: center;
  }
`
export const BlogMeta = styled.div`
  width: 100%;
  margin: 2rem 0 0rem 0;
`
export const BlogHeader = styled.div`
  display: flex;
  align-items: flex-start;
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }
`

export const GoToLink = styled.div`
  margin: 0 0.5rem;
  & a {
    &:hover {
      text-decoration: none;
    }
  }
`
export const BlogDescription = styled.div`
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* Limit to 3 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`
export const BlogHashTags = styled.div`
  width: 100%;
  margin-top: 1.5rem;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
`
